import React from 'react';
import { Link } from 'react-router-dom';
import styles from './SettingsListItem.module.css';
import { FiChevronRight } from 'react-icons/fi';

const SettingsListItem = ({
                              icon: Icon,
                              title,
                              currentValue,
                              onClick,
                              to,
                              children,
                              titleId // for react-intl
                          }) => {
    const content = (
        <>
            {Icon && <Icon className={styles.icon} />}
            <span className={styles.title}>{title}</span>
            {children ? (
                <div className={styles.customControl}>{children}</div>
            ) : (
                <>
                    {currentValue && <span className={styles.currentValue}>{currentValue}</span>}
                    {(to) && <FiChevronRight className={styles.chevron} />}
                </>
            )}
        </>
    );

    if (to) {
        return (
            <Link to={to} className={styles.listItem}>
                {content}
            </Link>
        );
    }

    if (onClick) {
        return (
            <button onClick={onClick} className={styles.listItem}>
                {content}
            </button>
        );
    }

    return (
        <div className={`${styles.listItem} ${styles.nonClickable}`}>
            {content}
        </div>
    );

    // return (
    //     <button onClick={onClick} className={`${styles.listItem} ${!onClick ? styles.nonClickable : ''}`} disabled={!onClick && !to}>
    //         {content}
    //     </button>
    // );
};

export default SettingsListItem;
